import { useEffect, useRef } from "react";
import Lenis from "@studio-freight/lenis";

// Global smooth-scroll singleton so route-change scroll-to-top can use it.
let lenisInstance = null;
export const getLenis = () => lenisInstance;

export const useSmoothScroll = () => {
  const rafRef = useRef(null);

  useEffect(() => {
    // Respect reduced-motion preference.
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      // Snappy but still smooth. Lower duration + higher wheel multiplier
      // eliminates the "laggy scroll" feel while keeping easing polished.
      duration: 0.7,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1.35,
      touchMultiplier: 2,
      lerp: 0.12,
    });
    lenisInstance = lenis;
    window.__lenis = lenis; // debug handle

    const raf = (time) => {
      lenis.raf(time);
      rafRef.current = requestAnimationFrame(raf);
    };
    rafRef.current = requestAnimationFrame(raf);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
};

export default useSmoothScroll;
